import {useTeamCandidateScope} from "./TeamCandidateScopeProvider";
import React, {useState} from "react";
import {InputNumber} from "antd";

const TeamPercentMarkupForm = (props) => {

    const {
        team,
        isDisabled,
        isLoading,
        updateTeamScope
    } = useTeamCandidateScope();

    const [model, setModel] = useState({percent_markup: ((parseFloat(team?.job_candidate?.percent_markup || 0)) * 100)});

    if (isLoading|| !team) {
        return null
    }
    return (
        <div className="flex flex-row gap-4 items-center">
            <div className="flex flex-row gap-2.5 items-center">
                <p className="text-base font-medium">
                    Percent Markup:
                </p>
                <div className="relative w-36">
                    <InputNumber
                        controls={false}
                        min={0}
                        step={0.01}
                        addonAfter="%"
                        precision={4}
                        value={model.percent_markup}
                        formatter={value => Number(value).toFixed(2)}
                        onChange={(value) => setModel({percent_markup: parseFloat(value)})}/>
                </div>
            </div>
            <button disabled={isDisabled} onClick={async () => {
                updateTeamScope({percent_markup: (model.percent_markup / 100)})
            }}
                    className="btn btn-dark text-xs py-1.5 5 px-2">
                Update
            </button>
        </div>
    )
}

export default TeamPercentMarkupForm